/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
import Marquee from 'react-fast-marquee';

interface MapMarqueeProps {
  objects?: any[];
}

export const MapMarquee: React.FC<MapMarqueeProps> = ({ objects = [] }) => {
  const showMarquee = objects.length > 0;
  const [marqueeText, setMarqueeText] = useState('');
  const [informational, setInformational] = useState(false);
  const [gradient, setGradient] = useState<[number, number, number]>([
    139, 0, 0,
  ]);
  const gradientColorString = `rgb(${gradient[0]},${gradient[1]},${gradient[2]})`;
  const [showDivider, setShowDivider] = useState(false);

  const marqueeTextRef = useRef<HTMLDivElement>(null);
  const marqueeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (objects.length === 0) {
      setMarqueeText('');
      setInformational(false);
      setShowDivider(false);
      return;
    }

    // Filter objects to only include those with specialAlert or informationalAlert and advisoryText
    const filteredObjects = objects.filter(
      (alert) =>
        (alert.specialAlert || alert.informationalAlert) &&
        alert.advisoryText &&
        alert.advisoryText.trim() !== ''
    );

    const isSpecial = filteredObjects.find(
      (alert) =>
        alert.specialAlert &&
        alert.advisoryText &&
        alert.advisoryText.trim() !== ''
    );
    setInformational(!isSpecial); // If any alert is special, set informational to false

    setMarqueeText(
      filteredObjects.map((alert) => alert.advisoryText).join(' | ') + ' '
    );
  }, [objects]);

  useEffect(() => {
    setGradient(informational ? [21, 79, 117] : [139, 0, 0]);
  }, [informational]);

  useEffect(() => {
    console.log("marqueeTextRef.current:", marqueeTextRef.current);
    console.log("marqueeRef.current:", marqueeRef.current);
    
    const checkDivider = () => {
      if (marqueeTextRef.current && marqueeRef.current) {
        const textWidth = marqueeTextRef.current.offsetWidth;
        const marqueeWidth = marqueeRef.current.offsetWidth;
        const showDividerValue = textWidth > marqueeWidth;
        console.log("setting show divider to " + showDividerValue);
        setShowDivider(showDividerValue);
      } else {
        console.log("Refs not ready, retrying...");
        setTimeout(checkDivider, 10);
      }
    };
    
    checkDivider();
  }, [marqueeText]);

  if (showMarquee && marqueeText !== '') {
    return (
      <div className="marqueeWrapper" ref={marqueeRef}>
        <Marquee
          className={
            informational ? 'marquee marquee-info' : 'marquee marquee-warning'
          }
          gradient={true}
          gradientColor={gradientColorString}
          gradientWidth={50}
        >
          {showDivider ? <div>&nbsp;|&nbsp;</div> : null}
          <div ref={marqueeTextRef}>{marqueeText}</div>
        </Marquee>
      </div>
    );
  } else {
    return null;
  }
};

export default MapMarquee;
